export enum CompanyStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface ICompany {
  id: string;
  created_at: string;
  name: string;
  status: CompanyStatus;
  contact: string;
}

export interface ICompanyDTO {
  id: string;
  name: string;
  contact: string;
  status?: CompanyStatus;
}
